

export const focusFirstError = (errors) => {
    if (!errors || Object.keys(errors).length === 0) return;
    
    // console.log(errors);
    // console.log();
    const errorFields = typeof errors[0] === "string" ? errors : Object.keys(errors);
    // console.log(errorFields);
    
    const firstErrorField = errorFields[0];
    const element = document.querySelector(`[name="${firstErrorField}"]`);
    
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'center' });
      element.focus();
    }
  };